<template>
  <div id="empresa">
    <div class="container-empresa">
      <h3 class="titulo">CONOCENOS</h3>
      <div class="flex">
        <div class="fondo">
          <div class="desc">
            <h3>100% MEXICANO</h3>
            <p>Hemos conformado un consorcio de empresas
              100% mexicano con más 40 años de experiencia en la comercializacion de frutas finas
              en México. Desde el 30 de noviembre de 1969 y a la fecha somos lideres indiscutibles
              en la Ciudad de México y Guadalajara, asi como en los estados
              del centro - occidente del pais, gracias al equipo de trabajo
              dividido en cuatro comercializadoras, ubicadas en las centrales Abasto
              de la ciudad de México y Guadalajara, Jalisco
              </p>
          </div>
        </div>
        <div class="fondo">
          <div class="desc">
            <p>En Grupo MLA nos empeñamos en satisfacer las necesidades de nuestros
              clientes de manera creativa y ética;
              somos un gran equipo humano profesional; contamos con una sólida infraestructura en
              logística y almacenaje en frío,
              y que en unión con proveedores de la mejor fruta fina a nivel mundial, además de las
              mejores agencias aduanales, líneas de trasporte aéreo, marítimo y terrestre, así como
              de las herramientas líderes en sistemas, hacen un todo
              para garantizar la calidad, higiene y conservación de nuestros productos.
            </p>
          </div>
        </div>
      </div>
      <div class="calidad-servicio">
        <h2 class="titulo">CALIDAD Y SERVICIO</h2>
        <div class="flex">
          <div class="bg">
            <div class="desc">
              <!-- <h4>Calidad y Servicio</h4> -->
              <p>
                La solidez de Grupo MLA se basa en la experiencia y estabilidad conseguidas a través
                de los años, lo que nos compromete con nuestros clientes,
                proveedores, personal, accionistas y público en general.
              </p>
            </div>
          </div>
            <div class="fondo">
              <div class="desc">
                <p>
                  En Grupo MLA nos esforzamos diariamente por mantener una actitud enfocada a la
                  calidad y el servicio. Proporcionamos a nuestros clientes atención especializada,
                  que se refleja en la asesoría profesional de nuestro equipo de ventas, quienes
                  orientan sobre la calidad, condiciones, variedades y sobre la manera
                  en que pueden conservarse las frutas en buen estado hasta el consumidor final
                </p>
              </div>
            </div>
        </div>
      </div>
      <div class="valores">
        <div class="flex">
          <div class="bg">
            <div class="desc">
              <!-- <h4>Calidad y Servicio</h4> -->
              <p>
                Grupo MLA cuenta con un departamento de control de calidad que se encarga de
                monitorear y supervisar el estado y condición de los productos desde que llegan a
                nuestras instalaciones hasta que salen a la venta, para garantizar la calidad de
                nuestros productos.
                <span class="db">Política</span>
                • Mejorar el nivel de satisfacción de nuestros clientes locales y foráneos. <br>
                • Mantener indicadores de desempeño para evaluar el modelo de calidad.<br>
              </p>
            </div>
          </div>
          <div class="bg">
            <div class="desc">
              <p class="tj">
                El éxito de <b>Grupo MLA</b> ha sido forjado a través del tiempo, basado
                principalmente en: <br>
                • Una coordinación y planeación interna enfocada en importaciones de productos
                de excelencia. <br>
                • Visita a los campos y sensibilización con el proveedor/productor
                de la demanda del mercado Mexicano. <br>
                • Mejora continua en la logística y manejo de los productos. <br>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="proveedores">
        <h2 class="titulo">PROVEEDORES</h2>
        <div class="text">
          <p class="p">
            La fruta que comercializa Grupo MLA proviene prácticamente de todo el mundo,
            pero en especial de: Canadá, Estados Unidos,
            Argentina, Perú, Chile, Ecuador, Nueva Zelanda, España y por supuesto, México.
          </p>
          <p class="p">
            Nuestros proveedores se distinguen por ser de clase mundial; se caracterizan por tener
            productos de alta calidad y de hacerlos llegar a Grupo MLA siguiendo un estricto
            protocolo de conservación (cadena de frío) para conservar su frescura.
          </p>
        </div>
        <div class="prov-images">
          <div class="prov">
           <swiper :options="swiperOption" :loop="true">
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner1.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner2.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner3.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner4.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner5.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner6.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner7.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner8.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner9.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner10.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner11.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner12.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner13.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner14.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner15.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner16.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner17.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner18.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner19.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner20.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner21.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner22.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner23.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner24.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner25.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner26.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner27.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner28.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner29.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner30.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner31.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner32.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner33.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner34.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner35.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner36.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner37.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner38.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner39.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner40.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner41.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner42.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner43.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner44.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner45.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner46.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner47.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner48.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner49.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner50.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner51.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner52.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner53.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner54.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner55.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner56.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner57.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner58.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner59.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner60.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner61.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner62.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner63.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner64.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner65.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner66.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner67.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner68.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner69.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner70.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner71.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner72.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner73.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner74.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner75.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner76.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner77.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide >
              <div class="prov">
                <img src="@/assets/images/banner78.png" alt="">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner79.png" alt="Sun wolrd">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner80.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner81.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner82.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner83.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner84.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner85.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner86.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner87.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner88.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner89.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner90.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner91.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner92.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner93.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner94.png" alt="RIOblanco">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner95.png" alt="Videxport">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner96.png" alt="Subsole">
              </div>
            </swiper-slide>
             <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner97.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner98.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner99.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner100.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner101.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner102.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner103.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner104.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prov">
                <img src="@/assets/images/banner105.png" alt="RIOblanco">
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
          </div>
          <div class="prov">
            <!-- <img src="@/assets/images/" alt="">
            <img src="@/assets/images/" alt="">
            <img src="@/assets/images/" alt="">
            <img src="@/assets/images/" alt="">
            <img src="@/assets/images/" alt=""> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
          600: {
            slidesPerView: 1,
          },
        },
        slidesPerView: 5,
        loop: true,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.active {
  background: green !important;
}
#empresa {
  .container-empresa {
    .desc {
      text-align: justify;
      overflow-y:unset;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 80%;
          height: 80%;
          padding: 5% 5%;
          font-size: 1.3em;
          background: rgba($color: #fff, $alpha: .8);
          // & > p {
          //   overflow-y: auto;
          // }
        }
    .btns {
      margin: 10% auto;
      margin-bottom: 4%;
      display: flex;
      justify-content: center;

      > div {
        width: 200px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 5px 15px;
        color: #fff;
        background: rgba(95, 93, 93, .3);
        border-radius: 10px;
        padding: 10px 30px;
      }
    }
    .flex {
      margin: 2% 5%;
      display: flex;
      height: 60vh;

      .fondo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 100%;
        background-image: url('../assets/images/producto11.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

      }
      .fondo:nth-child(2) {
        background-image: url('../assets/images/producto10.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: 50%;
      }
    }

    .titulo {
      font-size: 2.2em;;
      font-weight: 300;
      }

    .calidad-servicio,
    .valores {
      .m1{
        margin-top: 4%;
        margin-bottom: 4%;
      }
      .flex {
        .bg {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          .desc {
            padding: 4%;
          }

          .img {
            width: 100%;
            height: 100%;
            // background-image: url('../assets/images/mayra1.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
        .bg:nth-child(1){
          background-image: url('../assets/images/grid/litchi.jpg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .fondo:nth-child(1) {
          background-image: url('../assets/images/producto8.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
    .calidad-servicio {
      >.flex {
        >.bg {
          background: url('../assets/images/grid/litchi.jpg');
        }
        >.fondo {
          background: url('../assets/images/grid/7.jpg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
    .valores {
      .btns {
        margin-top: 4%;
      }
       >.flex {
         >.bg:nth-child(1) {
          background-image: url('../assets/images/grid/12.jpg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .bg:nth-child(2) {
          background-image: url('../assets/images/grid/aguacate.jpg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
    .proveedores {
      .text {
        margin: 0 auto;
        padding: 0 10%;
        font-size: 1.3em;;

      }
      .prov-images {
        margin-top: 10vh;
        .prov {

          img {
            width: 70%;
            height: 100%;
            max-height: 100%;
            max-width: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 630px) {
  .flex {
    flex-direction: column;
    height: 79vh !important;
    align-items: center;
  }
  .bg {
    width: 100% !important;
    height: 50% !important;
  }
  .fondo {
    width: 100% !important;
    height: 50% !important;
  }
  div.container {
    margin: 50px 0;
    width: 100%;
    height: auto;
  }
  #empresa .container div.flex {
    margin: 2% 0;
  }
  #empresa .container .proveedores .prov-images div.prov img {
    width: 40%;
    margin: auto;
  }

}
</style>
